'use client';

import { Card } from '@/components/ui/card';
import { GenerateSpinner } from '@/components/glitch-ui/generate-spinner';

interface BusinessGenerateLoadingProps {
  showBackButton?: boolean;
  onBackClick?: () => void;
  backButtonText?: string;
}

export function BusinessGenerateLoading(_: BusinessGenerateLoadingProps): JSX.Element {
  return (
    <div className='campaign-goal-generate flex-row space-y-6 !mt-0'>
      <div className="relative">
        <Card className='!border-none !shadow-none'>
          <GenerateSpinner text="" />
        </Card>
      </div>
    </div>
  );
}
